import { Rate, Tooltip } from "antd"
import { useLocation, useParams } from 'react-router-dom';
import { useEffect, useState } from "react";
import { useFetch } from "../../../hooks/useFetch/useFetch";
import { ExpandableText } from "../../atoms/ExpandableText";
import "../../../Styles/ReviewsAndFaQ.css"
import { LeftCircleTwoTone, RightCircleTwoTone, ShopOutlined } from "@ant-design/icons";
import googleLogo from "../../../assets/logo_google.png"
import { calculateDays } from "../../../common/utils/caculateDays";

export const WidgetsReviews = ({ id: webConfigId }) => {

    let { id: widgetId } = useParams();
    const key = webConfigId || widgetId;
    const location = useLocation();
    const storeCode = new URLSearchParams(location.search).get('storeCode');
    const locality = new URLSearchParams(location.search).get('locality');
    
    let extraQueryParams = storeCode ? '&storeCode=' + storeCode : '';    

    const { data: reviews, isLoading: reviewsLoading } = useFetch(
        `${process.env.REACT_APP_API}/web/reviews?key=${key}&widget=${!webConfigId}${extraQueryParams}` ,
        {},
        [],
    );

    const [itemsPerPage, setItemsPerPage] = useState(3);
    const [currentPage, setCurrentPage] = useState(1);

    useEffect(() => {
        const handleResize = () => {
            let newItemsPerPage = 4;

            if (window.innerWidth < 700) {
                newItemsPerPage = 1;
            } else if (window.innerWidth < 900) {
                newItemsPerPage = 2;
            } else if (window.innerWidth < 1024) {
                newItemsPerPage = 3;
            }

            if (newItemsPerPage !== itemsPerPage) {
                setItemsPerPage(newItemsPerPage);
                setCurrentPage(1);
            }
        };

        handleResize();

        window.addEventListener('resize', handleResize);

        return () => {
            window.removeEventListener('resize', handleResize);
        };
    }, [itemsPerPage]);

    const startIndex = (currentPage - 1) * itemsPerPage;
    const endIndex = Math.min(startIndex + itemsPerPage, reviews.length);
    const currentReviews = reviews.slice(startIndex, endIndex);

    const handleNextPage = () => {
        setCurrentPage(Math.min(currentPage + 1, Math.ceil(reviews.length / itemsPerPage)));
    };

    const handlePrevPage = () => {
        setCurrentPage(Math.max(currentPage - 1, 1));
    };

    return (
        <div style={{ padding: '20px 15px 0px 15px' }}>
            <div style={{ display: 'flex', gap: '30px', justifyContent: 'center' }}>
                {currentReviews.map((review, index) => {
                    return <div key={index} style={{ width: '300px' }}>
                        <div className='comment-review' style={{ height: '170px', overflow: 'auto' }}>
                            <div style={{ display: 'flex', flexDirection:'column', gap:'5px' }}>
                                <b><small style={{ marginLeft:'6px', color: 'black' }}>{calculateDays(review?.createdTime)}</small></b>
                                <div style={{width:'fit-content', border: '1px solid #3498DB', padding: '3px 5px', borderRadius: '20px', gap: '5px', display: 'flex', justifyContent:'flex-start' }}>
                                    <a><ShopOutlined /></a>
                                    <span style={{ color: '#3498DB', fontWeight: 600 }}>
                                        {review && review.locality ? 
                                        <Tooltip title={<span>{review?.addressLine}, {review?.locality}, {review?.administrativeArea}</span>}>
                                            {locality ? locality : review.locality}
                                        </Tooltip> : "Sin ubicación"}
                                    </span>
                                </div>
                            </div>

                            <ExpandableText
                                comment={review?.comment}
                                length={100} />
                        </div>
                        <div className="web-content-reviews-profile" style={{ position: 'relative' }}>
                            <div style={{ borderRadius: '50%', overflow: 'hidden', width: 50, height: 50, display: 'flex', justifyContent: 'center' }}>
                                <img src={review?.reviewerProfilePhotoUrl} style={{ height: '100%', width: 'auto' }} />
                            </div>

                            <div style={{ display: 'flex', flexDirection: 'column', gap: '5px' }}>
                                <p style={{ margin: 0, fontWeight: 500 }}>{review?.reviewerDisplayName}</p>
                                <Rate style={{ fontSize: '15px', color: 'orange' }} disabled defaultValue={review?.starRating} />
                            </div>

                            <div style={{ background: 'white', padding: 5, position: 'absolute', width: 30, height: 30, borderRadius: '50%', top: '50%', left: '10%', display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
                                <img src={googleLogo} style={{ height: '100%', width: 'auto' }} />
                            </div>

                        </div>

                    </div>
                })}
            </div>
            <div className="web-buttons">
                <button 
                    onClick={handlePrevPage} disabled={currentPage === 1}>
                    <LeftCircleTwoTone
                        twoToneColor={currentPage === 1 ? "lightgrey" : "darkgrey"}
                    />
                </button>
                <button
                    onClick={handleNextPage} disabled={endIndex >= reviews.length}>
                    <RightCircleTwoTone
                        twoToneColor={endIndex >= reviews.length ? "lightgrey" : "darkgrey"}
                    />
                </button>
            </div>
        </div>
    )
}